import { render, staticRenderFns } from "./OrgSettingsDeveloper.vue?vue&type=template&id=ad591534&scoped=true&"
import script from "./OrgSettingsDeveloper.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsDeveloper.vue?vue&type=style&index=0&id=ad591534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad591534",
  null
  
)

export default component.exports